import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EditDepositPromotionForm from '../EditDepositPromotionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function EditDepositPromotionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขรายการโปรโมชั่น`}
					description="แก้ไขรายการโปรโมชั่น"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditDepositPromotionForm />
		</div>
	)
}
